import AdminPanel from '../components/AdminPanel/AdminPanel';
import BasicAppPageWithSidebarTemplate from '../templates/BasicAppPageWithSidebarTemplate/BasicAppPageWithSidebarTemplate';
export default function AdminPanelPage() {
  return (
    <BasicAppPageWithSidebarTemplate>
      <AdminPanel />
    </BasicAppPageWithSidebarTemplate>
  );
}
